<template>
 <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 22 35">
    <path :fill="color" d="M21.7,23.3L20.4,22c-0.4-0.4-0.9-0.4-1.3,0l-6.3,6.3V1.3c0-0.5-0.3-1-0.9-1.1h-1.8C9.4,0.3,9.2,0.8,9.2,1.3v26.9L2.9,22
	c-0.4-0.4-0.9-0.4-1.3,0l-1.3,1.3c-0.2,0.2-0.3,0.4-0.3,0.6c0,0.2,0.1,0.5,0.3,0.6l10,10c0.2,0.2,0.4,0.3,0.6,0.3s0.5-0.1,0.6-0.3
	l10-10c0.2-0.2,0.3-0.4,0.3-0.6C21.9,23.7,21.8,23.4,21.7,23.3z"/>
  </svg>
</template>

<script>
  export default {
    props: {
      width: { type: String },
      height: { type: String },
      color: { type: String }
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/icons/arrowDown.vue